<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">

        <!-- ── KPI Cards ── -->
        <div class="row row-cols-2 row-cols-md-4 g-3 mt-1 mb-3">
          <div class="col">
            <div class="mv-kpi-card" style="border-top-color:#3b82f6;">
              <div class="mv-kpi-ico" style="background:#eff6ff;color:#3b82f6;">
                <i class="material-icons material-symbols-outlined">receipt_long</i>
              </div>
              <div>
                <div class="mv-kpi-lbl">ตั๋วคงค้างในระบบ</div>
                <div class="mv-kpi-val" style="color:#3b82f6;">
                  {{ fmNumber(kpiRemain) || '—' }}
                </div>
                <div class="mv-kpi-sub">ยอดรวมทุกเดือน (ไม่รวมอายัด)</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="mv-kpi-card" style="border-top-color:#0284c7;">
              <div class="mv-kpi-ico" style="background:#f0f9ff;color:#0284c7;">
                <i class="material-icons material-symbols-outlined">payments</i>
              </div>
              <div>
                <div class="mv-kpi-lbl">มูลค่าคงค้างรวม</div>
                <div class="mv-kpi-val" style="color:#0284c7;">
                  {{ fmNumber(kpiRemainValue) || '—' }}
                </div>
                <div class="mv-kpi-sub">ยอดรวมทุกเดือน (ไม่รวมอายัด)</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="mv-kpi-card" style="border-top-color:#16a34a;">
              <div class="mv-kpi-ico" style="background:#f0fdf4;color:#16a34a;">
                <i class="material-icons material-symbols-outlined">arrow_downward</i>
              </div>
              <div>
                <div class="mv-kpi-lbl">จำนำเดือนนี้ ({{ currentMonthLabel }})</div>
                <div class="mv-kpi-val" style="color:#16a34a;">
                  {{ fmNumber(kpiPawnThis) || '—' }}
                </div>
                <div class="mv-kpi-sub">{{ kpiPawnThisValue ? fmNumber(kpiPawnThisValue) + ' บาท' : 'ใบ' }}</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="mv-kpi-card" style="border-top-color:#f43f5e;">
              <div class="mv-kpi-ico" style="background:#fef2f2;color:#f43f5e;">
                <i class="material-icons material-symbols-outlined">arrow_upward</i>
              </div>
              <div>
                <div class="mv-kpi-lbl">ไถ่ถอนเดือนนี้ ({{ currentMonthLabel }})</div>
                <div class="mv-kpi-val" style="color:#f43f5e;">
                  {{ fmNumber(kpiRedeemThis) || '—' }}
                </div>
                <div class="mv-kpi-sub">{{ kpiRedeemThisValue ? fmNumber(kpiRedeemThisValue) + ' บาท' : 'ใบ' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Main Card ── -->
        <div class="card mt-0">
          <div class="card-header mb-0 pb-2">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <!-- ชื่อหน้า + checkboxes -->
              <div class="d-flex align-items-center flex-wrap gap-3">
                <h5 class="mb-0">{{ $t("content.gmovement") }}</h5>
                <div class="d-flex align-items-center gap-2 ms-2">
                  <span class="form-label m-0 me-1" style="font-size:15px;">{{ $t("content.select") }}:</span>
                  <material-checkbox v-model="selnumTk" :checked="selnumTk">
                    {{ $t("content.amtk") }}
                  </material-checkbox>
                  <material-checkbox v-model="selAmount" :checked="selAmount">
                    {{ $t("content.amntotalval") }}
                  </material-checkbox>
                </div>
              </div>

              <!-- View Toggle -->
              <div class="d-flex gap-2">
                <material-button
                  :color="viewMode === 'visual' ? 'primary' : 'primary'"
                  :variant="viewMode === 'visual' ? 'fill' : 'outline'"
                  size="sm" class="m-0 text-nowrap"
                  @click="setViewMode('visual')">
                  <i class="material-icons material-symbols-outlined">insert_chart</i>
                  รูปภาพ
                </material-button>
                <material-button
                  :color="viewMode === 'table' ? 'primary' : 'primary'"
                  :variant="viewMode === 'table' ? 'fill' : 'outline'"
                  size="sm" class="m-0 text-nowrap"
                  @click="setViewMode('table')">
                  <i class="material-icons material-symbols-outlined">table_rows</i>
                  ตาราง
                </material-button>
              </div>
            </div>
          </div>

          <div class="card-body pt-2">

            <!-- ══════════ VISUAL VIEW ══════════ -->
            <div v-if="viewMode === 'visual'">

              <!-- Row 1: Remaining Focus Section -->
              <div class="mv-remain-section mb-3">
                <div class="mv-remain-head">
                  <div class="mv-remain-ico">
                    <i class="material-icons material-symbols-outlined">receipt_long</i>
                  </div>
                  <div>
                    <div class="mv-remain-title">จำนวนตั๋วที่เหลือ ณ สิ้นแต่ละเดือน (Remaining)</div>
                    <div class="mv-remain-sub">ตั๋วที่ยังคงค้างอยู่ในระบบ ณ วันสุดท้ายของแต่ละเดือน (12 เดือนล่าสุด)</div>
                  </div>
                  <span class="mv-badge ms-auto" :class="isValOnly ? 'badge-amber' : 'badge-sky'">
                    {{ isValOnly ? 'มูลค่า (บาท)' : 'จำนวนตั๋ว' }}
                  </span>
                </div>

                <!-- Mini KPI chips: 6 เดือนล่าสุด -->
                <div class="mv-remain-chips">
                  <div v-for="item in remainLast6" :key="item.key" class="mv-remain-chip">
                    <div class="chip-label">{{ item.label }}</div>
                    <div class="chip-num">{{ isValOnly ? fmNumber(item.val) : fmNumber(item.count) }}</div>
                    <div v-if="!isValOnly" class="chip-sub">{{ fmNumber(item.val) }}</div>
                    <div v-if="item.diff !== null" class="chip-change" :class="item.diff >= 0 ? 'up' : 'down'">
                      {{ item.diff >= 0 ? '▲' : '▼' }} {{ Math.abs(item.diff).toLocaleString() }}
                    </div>
                  </div>
                </div>

                <!-- Remaining Chart: full width -->
                <div class="mv-remain-chart-wrap">
                  <div style="position:relative;height:260px;">
                    <Bar :data="remainChartData" :options="remainChartOptions" />
                  </div>
                </div>
              </div>

              <!-- Row 2: Stacked Bar + % Line -->
              <div class="row g-3 mb-3">
                <div class="col-lg-8">
                  <div class="card shadow-sm h-100">
                    <div class="card-body pb-2">
                      <h6 class="mb-3 d-flex align-items-center gap-2">
                        ปริมาณธุรกรรมแยกประเภท (12 เดือนล่าสุด)
                        <span class="mv-badge" :class="isValOnly ? 'badge-amber' : 'badge-indigo'">
                          {{ isValOnly ? 'มูลค่า (บาท)' : 'จำนวนตั๋ว' }}
                        </span>
                      </h6>
                      <div style="position:relative;height:300px;">
                        <Bar :data="mainChartData" :options="mainChartOptions" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card shadow-sm h-100">
                    <div class="card-body pb-2">
                      <h6 class="mb-3">% ผลัดและหลุด รายเดือน</h6>
                      <div style="position:relative;height:300px;">
                        <Line :data="percentChartData" :options="percentChartOptions" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <!-- ══════════ END VISUAL ══════════ -->

            <!-- ══════════ TABLE VIEW ══════════ -->
            <div v-else class="table-responsive mt-2">
              <table class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th>{{ $t("content.item") }}</th>
                    <th class="text-center">{{ $t("content.more12m") }}</th>
                    <th v-for="month in dynamicMonths" :key="month.Value" class="text-center">
                      {{ month.Label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- แถวข้อมูลปกติ -->
                  <tr v-for="(row, index) in rows" :key="index"
                    :class="row.apiKey === 'remaining' ? 'mv-row-remain' : ''">
                    <td class="text-left">
                      <span v-if="row.apiKey === 'remaining'" class="fw-bold" style="color:#0284c7;">
                        <i class="material-icons material-symbols-outlined me-1" style="font-size:14px;vertical-align:middle;">receipt_long</i>
                        {{ row.name }}
                      </span>
                      <span v-else>{{ row.name }}</span>
                    </td>
                    <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                      <div v-if="selnumTk && apiData?.[mKey]?.[row.apiKey]">
                        <span
                          v-if="row.apiKey !== 'inout'"
                          class="font-weight-bold"
                          style="cursor:pointer; text-decoration:underline; color: blue;"
                          @click="mKey !== '00000' ? goToHistory(mKey, row) : null"
                        >
                          {{ fmNumber(apiData?.[mKey]?.[row.apiKey]) }}
                        </span>
                        <span v-else>{{ fmNumber(apiData?.[mKey]?.[row.apiKey]) }}</span>
                      </div>
                      <div v-if="selAmount && apiData?.[mKey]?.[row.apiValueKey]">
                        <template v-if="selnumTk">
                          <small class="text-muted">({{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }})</small>
                        </template>
                        <template v-else>
                          <span
                            v-if="row.apiKey !== 'inout'"
                            class="font-weight-bold"
                            style="cursor:pointer; text-decoration:underline; color: blue;"
                            @click="mKey !== '00000' ? goToHistory(mKey, row) : null"
                          >
                            {{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }}
                          </span>
                          <span v-else>{{ fmNumber(apiData?.[mKey]?.[row.apiValueKey]) }}</span>
                        </template>
                      </div>
                    </td>
                  </tr>

                  <!-- % ของผลัด -->
                  <tr class="table-secondary font-weight-bold">
                    <td class="text-left">% ของผลัด</td>
                    <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                      <div v-if="selnumTk">{{ calculatePercent(apiData?.[mKey]?.postpone, apiData?.[mKey]?.pawn) }}</div>
                      <div v-if="selAmount" :class="{'text-muted small': selnumTk}">
                        {{ calculatePercent(apiData?.[mKey]?.postponeValue, apiData?.[mKey]?.pawnValue, selnumTk) }}
                      </div>
                    </td>
                  </tr>

                  <!-- % ของหลุด -->
                  <tr class="table-secondary font-weight-bold">
                    <td class="text-left">% ของหลุด</td>
                    <td v-for="mKey in ['00000', ...dynamicMonths.map(m => m.Value)]" :key="mKey" class="text-center">
                      <div v-if="selnumTk">{{ calculatePercent(apiData?.[mKey]?.breaking, apiData?.[mKey]?.pawn) }}</div>
                      <div v-if="selAmount" :class="{'text-muted small': selnumTk}">
                        {{ calculatePercent(apiData?.[mKey]?.breakingValue, apiData?.[mKey]?.pawnValue, selnumTk) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- ══════════ END TABLE ══════════ -->

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import moment from 'moment';

import { Bar, Line, Doughnut } from 'vue-chartjs';
import {
  Chart as ChartJS, CategoryScale, LinearScale,
  BarElement, LineElement, PointElement,
  ArcElement, Tooltip, Legend, Filler,
} from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend, Filler);

import { useStockMovementStore } from '@/stores/stockmovement';

const storest = useStockMovementStore();
const { t } = useI18n();

// ── State ──────────────────────────────────────────────────
const apiData  = ref({});
const selnumTk = ref(true);
const selAmount = ref(false);
const viewMode  = ref('visual');

const rows = [
  { name: 'จำนำ',                                            apiKey: 'pawn',         apiValueKey: 'pawnValue' },
  { name: 'ต่อดอก',                                          apiKey: 'interest',     apiValueKey: 'interestValue' },
  { name: 'เพิ่มต้น',                                        apiKey: 'incPrinciple', apiValueKey: 'incValue' },
  { name: 'ลดต้น',                                           apiKey: 'decPrinciple', apiValueKey: 'decValue' },
  { name: 'ไถ่ถอน (ทำธุรกรรมใหม่)',                          apiKey: 'redeemNewTx',  apiValueKey: 'redeemNewTxValue' },
  { name: 'ไถ่ถอนจริง',                                      apiKey: 'redeem',       apiValueKey: 'redeemValue' },
  { name: 'จำนวนตั๋วที่เหลือตามวันที่ทำธุรกรรมของเดือนนั้นๆ', apiKey: 'remaining',    apiValueKey: 'remainValue' },
  { name: 'จำนวนตั๋วที่เข้าออกของเดือนนั้นๆ',                 apiKey: 'inout',        apiValueKey: 'inoutValue' },
  { name: 'อายัด',                                           apiKey: 'freeze',       apiValueKey: 'freezeValue' },
  { name: 'ของผลัด',                                         apiKey: 'postpone',     apiValueKey: 'postponeValue' },
  { name: 'ของหลุด',                                         apiKey: 'breaking',     apiValueKey: 'breakingValue' },
];

const key = JSON.parse(localStorage.getItem("shop_seleted"));

// ── Months ─────────────────────────────────────────────────
const dynamicMonths = computed(() => {
  const months = [];
  const now = new Date();
  for (let i = 11; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = `${d.toLocaleString('th-TH', { month: 'short' })}-${d.getFullYear().toString().slice(-2)}`;
    const monthVal = d.getMonth() + 1;
    const value = `${d.getFullYear()}${monthVal.toString().padStart(2, '0')}`;
    months.push({ Label: label, Value: value });
  }
  return months;
});

const currentMonthKey   = computed(() => dynamicMonths.value[dynamicMonths.value.length - 1]?.Value);
const currentMonthLabel = computed(() => dynamicMonths.value[dynamicMonths.value.length - 1]?.Label ?? '');

const latestMonthKey = computed(() => {
  const months = dynamicMonths.value;
  for (let i = months.length - 1; i >= 0; i--) {
    if (apiData.value?.[months[i].Value]?.remaining) return months[i].Value;
  }
  return months[months.length - 1]?.Value ?? null;
});

const latestMonthLabel = computed(() => {
  const found = dynamicMonths.value.find(m => m.Value === latestMonthKey.value);
  return found?.Label ?? '';
});

// ── KPI ────────────────────────────────────────────────────
const kpiRemain = computed(() => {
  const allKeys = ['00000', ...dynamicMonths.value.map(m => m.Value)];
  return allKeys.reduce((sum, k) => sum + (apiData.value?.[k]?.remaining ?? 0), 0);
});

const kpiRemainValue = computed(() => {
  const allKeys = ['00000', ...dynamicMonths.value.map(m => m.Value)];
  return allKeys.reduce((sum, k) => sum + (apiData.value?.[k]?.remainValue ?? 0), 0);
});
const kpiPawnThis       = computed(() => apiData.value?.[currentMonthKey.value]?.pawn ?? 0);
const kpiPawnThisValue  = computed(() => apiData.value?.[currentMonthKey.value]?.pawnValue ?? 0);
const kpiRedeemThis     = computed(() => apiData.value?.[currentMonthKey.value]?.redeem ?? 0);
const kpiRedeemThisValue = computed(() => apiData.value?.[currentMonthKey.value]?.redeemValue ?? 0);

// ── Helpers ────────────────────────────────────────────────
const isValOnly = computed(() => selAmount.value && !selnumTk.value);

const fmNumber = (val) => {
  if (val === undefined || val === null || val === 0) return '';
  return Number(val).toLocaleString(undefined, { minimumFractionDigits: val % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
};

const fmMillion = (val) => {
  if (!val) return '';
  if (val >= 1_000_000) return (val / 1_000_000).toLocaleString('th-TH', { maximumFractionDigits: 1 }) + ' ล.';
  if (val >= 1_000)     return (val / 1_000).toLocaleString('th-TH', { maximumFractionDigits: 1 }) + ' พ.';
  return val.toLocaleString('th-TH', { maximumFractionDigits: 0 });
};

const fmM = (val) => {
  if (!val && val !== 0) return '';
  return (val / 1_000_000).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' M';
};

const calculatePercent = (part, total, useBrackets = false) => {
  if (!total || total === 0 || !part || part === 0) return '';
  const result = (part / total) * 100;
  if (result === 0) return '';
  const formatted = result.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
  return useBrackets ? `(${formatted})` : formatted;
};

const CHART_FONT = "'Sarabun', 'Noto Sans Thai', sans-serif";

// ── Chart: Main Stacked Bar ────────────────────────────────
const mainChartData = computed(() => {
  const col = (countKey, valKey) =>
    dynamicMonths.value.map(m => apiData.value?.[m.Value]?.[isValOnly.value ? valKey : countKey] || 0);
  return {
    labels: dynamicMonths.value.map(m => m.Label),
    datasets: [
      { label: 'จำนำ',    backgroundColor: '#3b82f6', data: col('pawn',         'pawnValue'),     stack: 'a', borderRadius: 3, maxBarThickness: 48 },
      { label: 'ต่อดอก',  backgroundColor: '#10b981', data: col('interest',     'interestValue'), stack: 'a', borderRadius: 3, maxBarThickness: 48 },
      { label: 'เพิ่มต้น', backgroundColor: '#8b5cf6', data: col('incPrinciple', 'incValue'),      stack: 'a', borderRadius: 3, maxBarThickness: 48 },
      { label: 'ลดต้น',   backgroundColor: '#f59e0b', data: col('decPrinciple', 'decValue'),      stack: 'a', borderRadius: 3, maxBarThickness: 48 },
      { label: 'ไถ่ถอน',  backgroundColor: '#f43f5e', data: col('redeem',       'redeemValue'),   stack: 'a', borderRadius: 3, maxBarThickness: 48 },
    ],
  };
});

const mainChartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: { stacked: true, grid: { display: false }, ticks: { font: { family: CHART_FONT, size: 13, weight: '600' } } },
    y: {
      stacked: true, grid: { color: '#eef0f6' }, border: { display: false },
      ticks: {
        font: { family: CHART_FONT, size: 13 },
        callback: v => isValOnly.value ? fmM(v) : v.toLocaleString(),
      },
    },
  },
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'rectRounded', boxWidth: 12, boxHeight: 12, padding: 14, font: { family: CHART_FONT, weight: '600', size: 14 } } },
    tooltip: { callbacks: { label: c => ` ${c.dataset.label}: ${isValOnly.value ? fmM(c.parsed.y) : c.parsed.y.toLocaleString() + ' ใบ'}` } },
  },
}));

// ── Chart: % Postpone & Breaking ──────────────────────────
const percentChartData = computed(() => ({
  labels: dynamicMonths.value.map(m => m.Label),
  datasets: [
    {
      label: '% ของผลัด',
      data: dynamicMonths.value.map(m => {
        const d = apiData.value?.[m.Value];
        return d?.pawnValue ? +((d.postponeValue / d.pawnValue) * 100).toFixed(2) : 0;
      }),
      borderColor: '#d97706', backgroundColor: 'rgba(217,119,6,.1)', fill: true,
      tension: 0.35, pointRadius: 4, pointHoverRadius: 6, borderWidth: 2.5,
    },
    {
      label: '% ของหลุด',
      data: dynamicMonths.value.map(m => {
        const d = apiData.value?.[m.Value];
        return d?.pawnValue ? +((d.breakingValue / d.pawnValue) * 100).toFixed(2) : 0;
      }),
      borderColor: '#dc2626', backgroundColor: 'rgba(220,38,38,.07)', fill: true,
      tension: 0.35, pointRadius: 4, pointHoverRadius: 6, borderWidth: 2.5,
    },
  ],
}));

const percentChartOptions = {
  responsive: true, maintainAspectRatio: false,
  scales: {
    x: { grid: { display: false }, ticks: { font: { family: CHART_FONT, size: 13, weight: '600' } } },
    y: { grid: { color: '#eef0f6' }, border: { display: false }, ticks: { callback: v => v + '%', font: { family: CHART_FONT, size: 13 } } },
  },
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', boxWidth: 10, boxHeight: 10, padding: 14, font: { family: CHART_FONT, weight: '600', size: 14 } } },
    tooltip: { callbacks: { label: c => ` ${c.dataset.label}: ${c.parsed.y}%` } },
  },
};

// ── Remaining Focus: mini KPI chips ───────────────────────
const remainLast6 = computed(() => {
  const last6 = dynamicMonths.value.slice(6);
  return last6.map((m, i) => {
    const d     = apiData.value?.[m.Value];
    const count = d?.remaining ?? 0;
    const val   = d?.remainValue ?? 0;
    const prev  = i > 0 ? (apiData.value?.[last6[i - 1].Value]?.remaining ?? null) : null;
    const diff  = prev !== null ? count - prev : null;
    return { key: m.Value, label: m.Label, count, val, diff };
  });
});

// ── Chart: Remaining Line + Inout Bar ─────────────────────
const remainChartData = computed(() => {
  const col = (countKey, valKey) =>
    dynamicMonths.value.map(m => apiData.value?.[m.Value]?.[isValOnly.value ? valKey : countKey] || 0);
  return {
    labels: dynamicMonths.value.map(m => m.Label),
    datasets: [
      {
        label: isValOnly.value ? 'มูลค่าคงค้าง' : 'ตั๋วคงค้าง',
        type: 'line',
        data: col('remaining', 'remainValue'),
        borderColor: '#0284c7', backgroundColor: 'rgba(2,132,199,.1)', fill: true,
        tension: 0.35, pointRadius: 5, pointHoverRadius: 7, borderWidth: 3,
        pointBackgroundColor: '#fff', pointBorderWidth: 2.5,
        yAxisID: 'y',
      },
      {
        label: isValOnly.value ? 'inout มูลค่า' : 'inout ตั๋ว',
        type: 'bar',
        data: col('inout', 'inoutValue'),
        backgroundColor: 'rgba(16,185,129,.2)',
        borderRadius: 5, maxBarThickness: 28,
        yAxisID: 'y2',
      },
    ],
  };
});

const remainChartOptions = computed(() => ({
  responsive: true, maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  scales: {
    x: { grid: { display: false }, ticks: { font: { family: CHART_FONT, size: 13, weight: '600' } } },
    y: {
      position: 'left', grid: { color: '#dbeafe' }, border: { display: false },
      ticks: { callback: v => isValOnly.value ? fmM(v) : v.toLocaleString(), font: { family: CHART_FONT, size: 13 } },
    },
    y2: {
      display: true, position: 'right', grid: { display: false }, border: { display: false },
      ticks: { callback: v => isValOnly.value ? fmM(v) : v.toLocaleString(), font: { family: CHART_FONT, size: 13 }, color: '#10b981' },
    },
  },
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', boxWidth: 10, boxHeight: 10, padding: 14, font: { family: CHART_FONT, weight: '600', size: 14 } } },
    tooltip: { callbacks: { label: c => ` ${c.dataset.label}: ${isValOnly.value ? fmM(c.parsed.y) : c.parsed.y.toLocaleString() + ' ใบ'}` } },
  },
}));

// ── Chart: Pie (latest month) ─────────────────────────────
const pieChartData = computed(() => {
  const d = apiData.value?.[latestMonthKey.value] ?? {};
  return {
    labels: ['จำนำ', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น', 'ไถ่ถอน'],
    datasets: [{
      data: [d.pawn || 0, d.interest || 0, d.incPrinciple || 0, d.decPrinciple || 0, d.redeem || 0],
      backgroundColor: ['#3b82f6', '#10b981', '#8b5cf6', '#f59e0b', '#f43f5e'],
      borderWidth: 3, borderColor: '#fff', hoverOffset: 6,
    }],
  };
});

const pieChartOptions = {
  responsive: true, maintainAspectRatio: false, cutout: '62%',
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', boxWidth: 10, boxHeight: 10, padding: 12, font: { family: CHART_FONT, weight: '600', size: 14 } } },
    tooltip: { callbacks: { label: c => ` ${c.label}: ${c.parsed.toLocaleString()} ใบ` } },
  },
};

// ── Chart: Remaining Ranking Bar ──────────────────────────
const remainRankChartData = computed(() => {
  const colKey = isValOnly.value ? 'remainValue' : 'remaining';
  const sorted = [...dynamicMonths.value]
    .map(m => ({ label: m.Label, val: apiData.value?.[m.Value]?.[colKey] || 0 }))
    .sort((a, b) => b.val - a.val)
    .slice(0, 6);
  return {
    labels: sorted.map(d => d.label),
    datasets: [{
      data: sorted.map(d => d.val),
      backgroundColor: sorted.map((_, i) => i === 0 ? '#0284c7' : '#bfdbfe'),
      borderRadius: { topLeft: 5, topRight: 5 }, borderSkipped: false, maxBarThickness: 44,
    }],
  };
});

const remainRankChartOptions = computed(() => ({
  responsive: true, maintainAspectRatio: false,
  scales: {
    x: { grid: { display: false }, ticks: { font: { family: CHART_FONT, size: 13, weight: '600' } } },
    y: {
      grid: { color: '#eef0f6' }, border: { display: false },
      ticks: { callback: v => isValOnly.value ? fmMillion(v) : v.toLocaleString(), font: { family: CHART_FONT, size: 13 } },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: { callbacks: { label: c => ` ${isValOnly.value ? fmMillion(c.parsed.y) + ' บาท' : c.parsed.y.toLocaleString() + ' ใบ'}` } },
  },
}));

// ── View mode ──────────────────────────────────────────────
function setViewMode(mode) {
  viewMode.value = mode;
}

// ── Visual mode: enforce single selection ─────────────────
watch(viewMode, (mode) => {
  if (mode === 'visual' && selAmount.value && selnumTk.value) {
    selAmount.value = false;
  } else if (mode === 'visual' && !selnumTk.value && !selAmount.value) {
    selnumTk.value = true;
  }
});

watch(selnumTk, (val) => {
  if (viewMode.value !== 'visual') return;
  if (val) { selAmount.value = false; }
  else if (!selAmount.value) { selnumTk.value = true; }
});

watch(selAmount, (val) => {
  if (viewMode.value !== 'visual') return;
  if (val) { selnumTk.value = false; }
  else if (!selnumTk.value) { selAmount.value = true; }
});

// ── API ────────────────────────────────────────────────────
const loadDataReportApi = async () => {
  apiData.value = {};
  const payload = { groupUid: key.groupUid, shopUid: key.uid };
  const response = await storest.txSummaryFetch(payload);
  if (response?.status === 200 && response.data?.rtnDesc === 'success' && response.data?.data) {
    apiData.value = response.data.data;
  }
};

loadDataReportApi();

// ── Navigate to History ────────────────────────────────────
const goToHistory = (monthValue, row) => {
  const start = moment(monthValue, "YYYYMM").startOf('month').format('YYYY-MM-DDT00:00:00');
  const end   = moment(monthValue, "YYYYMM").endOf('month').format('YYYY-MM-DDT23:59:59');
  const valueMap = {
    'pawn': 3, 'interest': 4, 'incPrinciple': 5, 'decPrinciple': 6, 'redeem': 7,
    'redeemNewTx': 21, 'remaining': 22, 'freeze': 23, 'postpone': 24, 'breaking': 25,
  };
  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify({ start_date: start, end_date: end, value: valueMap[row.apiKey] || 0 }));
  window.location.assign("#/generals/history");
};
</script>

<style lang="scss" scoped>

/* ── KPI Cards ── */
.mv-kpi-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 1px 4px rgba(26, 34, 51, 0.06), 0 4px 14px rgba(26, 34, 51, 0.06);
  display: flex;
  align-items: center;
  gap: 14px;
  border-top: 3px solid transparent;
  height: 100%;
}

.mv-kpi-ico {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i { font-size: 24px; }
}

.mv-kpi-lbl {
  font-size: 14px;
  font-weight: 600;
  color: #67748e;
  margin-bottom: 2px;
}

.mv-kpi-val {
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1.15;
}

.mv-kpi-sub {
  font-size: 13px;
  color: #9fa5b1;
  margin-top: 2px;
}


/* ── Badge tags ── */
.mv-badge {
  font-size: 13px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 99px;

  &.badge-indigo { background: #eef2ff; color: #4f46e5; }
  &.badge-amber  { background: #fffbeb; color: #d97706; }
  &.badge-sky    { background: #f0f9ff; color: #0284c7; }
}

/* ── Remaining Focus Section ── */
.mv-remain-section {
  background: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);
  border: 1.5px solid #bfdbfe;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(26, 34, 51, 0.06), 0 4px 14px rgba(26, 34, 51, 0.06);
  padding: 20px 22px;
}

.mv-remain-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.mv-remain-ico {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6, #0284c7);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i { font-size: 22px; }
}

.mv-remain-title {
  font-size: 16px;
  font-weight: 800;
  color: #1e40af;
}

.mv-remain-sub {
  font-size: 14px;
  color: #4b6a9e;
  margin-top: 2px;
}

/* Mini KPI Chips */
.mv-remain-chips {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  margin-bottom: 14px;

  @media (max-width: 1100px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 600px)  { grid-template-columns: repeat(2, 1fr); }
}

.mv-remain-chip {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 11px 13px;
  text-align: center;

  .chip-label { font-size: 15px; font-weight: 600; color: #6b8ab4; margin-bottom: 3px; }
  .chip-num   { font-size: 30px; font-weight: 800; color: #1d4ed8; letter-spacing: -0.5px; line-height: 1.2; }
  .chip-sub   { font-size: 15px; color: #64748b; margin-top: 2px; }
  .chip-change { font-size: 15px; font-weight: 700; margin-top: 4px; }
  .up   { color: #16a34a; }
  .down { color: #dc2626; }
}

/* Remaining Chart Wrapper */
.mv-remain-chart-wrap {
  background: rgba(255, 255, 255, 0.75);
  border-radius: 12px;
  padding: 14px 16px;
  border: 1px solid #bfdbfe;
}

/* ── Remaining Row in Table ── */
.mv-row-remain {
  td {
    background-color: #eff6ff !important;
    border-top: 2px solid #bfdbfe;
    border-bottom: 2px solid #bfdbfe;
    font-weight: 700;

    &:first-child {
      border-left: 4px solid #0284c7;
    }
  }
}

</style>
